module.exports = __webpack_public_path__ + "static/nabassu-957d5e5e604f043561914069863f8c94.png";